const i18n = {
	headerRegister: {
		0 : "Рэгістрацыя знешняга адміністратара",
		1 : "Регистрация внешнего администратора"
	},
	registerOrg: {
		0 : "Зарэгістраваць знешняга адміністратара",
		1 : "Зарегистрировать внешнего администратора"
	},
	tipLoading: {
		0 : "Пачакайце, ідзе загрузка...",
		1 : "Подождите, идет загрузка..."
	}
}
export default i18n